import { Link } from 'react-router-dom'

const Quote4: React.FC = () => {

    return (
        <section className="wpo-quote-section-s4">
            <div className="container">
                <div className="quote-wrap">
                    <div className="quote-title">
                        <h2 className="poort-text poort-in-right">From Yes to Forever, We Plan It All.</h2>
                        <p>At Bohu, we believe that weddings should be stress-free, elegant, and deeply
                            personal. With our expertise in planning,
                            styling, and vendor management, we transform visions into reality while keeping your
                            traditions, style, and budget in
                            mind. Whether you dream of a classic, modern, or destination wedding, Bohu is here
                            to craft timeless memories that you
                            and your guests will cherish forever.</p>
                        <div className="quote-btn">
                            <Link to="/about" className="theme-btn">Let’s Celebrate Our Love</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Quote4;